import Vue from 'vue'
import Router from 'vue-router'
import firebase from 'firebase'

//const Login = () => import('@/views/Login') to allow cloak to work, so we don't see a flash of the sidebar when we refresh the login page, this isn't lazy loaded
import Login from '@/views/Login.vue';
const Home = () => import('@/views/Home')
const Settings = () => import('@/views/Settings')
const Help = () => import('@/views/Help')
const Paint = () => import('@/views/Paint')
const Batch = () => import('@/views/Batch')
const Library = () => import('@/views/Library')
const Buy = () => import('@/views/Buy')

Vue.use(Router)

let router = new Router({
  //https://router.vuejs.org/en/essentials/history-mode.html
  mode: 'history', //won't use hashmode URLs, so requires we redirect 404 errors to index.html
  //https://vueschool.io/articles/vuejs-tutorials/vue-js-router-performance/
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: { hideNavigation: true }
    },
    {
      path: '/library',
      name: 'Library',
      component: Library,
      meta: {
        auth: true
      }
    },
    {
      path: '/library/:uuid',
      name: 'LibraryItem',
      component: Library,
      props: true,
      meta: {
        auth: true
      }
    },
    {
      path: '/buy/:request_id',
      name: 'Buy',
      component: Buy,
      props: true,
      meta: {
        auth: true
      }
    },
    {
      path: '/paint',
      name: 'Paint',
      component: Paint,
      props: true,
      meta: {
        auth: true
      }
    },
    {
      path: '/batch',
      name: 'Batch',
      component: Batch,
      props: true,
      meta: {
        auth: true
      }
    },
    {
      path: '/paint/:step',
      name: 'PaintStep',
      component: Paint,
      props: true,
      meta: {
        auth: true
      }
    },
    {
      path: '/help',
      name: 'Help',
      component: Help,
      meta: {
        auth: true
      }
    },
    {
      path: '/settings',
      name: 'Settings',
      component: Settings,
      meta: {
        auth: true
      }
    },
    {
      path: '/home',
      name: 'Home',
      component: Home,
    },
    {
      path: '/',
      redirect: '/home'
    },

  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.auth)) {
    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        next()
      } else {
        next({
          path: "/login",
        })
      }
    })
  }
  else {
    next()
  }
})

export default router
